import { CurrentUser } from "../auth-state/auth.model";
import { ProviderState } from "../provider/provider.reducer";
import { PolicyHolderState } from "../policyholder/policyholder.reducer";
import { DropdownState } from "../../interfaces/dropdown.state";
import { NotificationState } from "../notification/notification.reducer";
import { EnrolleeState } from "../enrollee/enrollee.reducer";

export interface AuthState {
   currentUser: CurrentUser | null;
  loginRedirect: string | null;
  initialized: boolean;
}

export interface AppState {
  auth: AuthState;
  provider: ProviderState;
  policyholder: PolicyHolderState;
  dropdown: DropdownState;
  notification: NotificationState;
  enrollee: EnrolleeState;

}

export enum StateKeys {
  AUTH = 'auth',
  PROVIDER = 'provider',
  POLICYHOLDER = 'policyholder',
  DROPDOWN = 'dropdown',
  NOTIFICATION = 'notification',
  ENROLLEE = 'enrollee',
}
